export default function MediatorPage() {
  return (
    <ul>
      <li>Mediator: </li>
    </ul>
  );
}
